import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler,  HttpResponse, HttpEvent} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TryCatchStmt } from '@angular/compiler';


@Injectable({
  providedIn: 'root'
})
export class LogInterceptorService {

  constructor() { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      let userData = JSON.parse(localStorage.getItem('Usuario'));
      var token = 'Bearer '+userData['token'];
    } catch (error) {
      
    }
   
    if (token ==null){token="Bearer"}
    req =req.clone({
      setHeaders:{Authorization: token ?? '',"x-api-key": "ns0IjjmkKM2EttxiJ598i3lJgbSigZUl9kfjlAcm"}
    });
  
    return next.handle(req);
   
  }
}
